import axios from 'axios';

export default {
  template: "#vue-brands",
  delimiters: ["${", "}"],
  data: function () {
    return {
      collections: [],
      all_brands: [],
      query: null,
      letter: 'all'
    };
  },
  methods: {
    setLetter: function (character) {
      this.letter = character;
    },
    filter: function () {
      this.collections = this.all_brands.filter(brand => {
        let query_match = true;
        let letter_match = true;
        if (this.query) {
          query_match = brand.title.toLowerCase().includes(this.query.toLowerCase());
        }
        if (this.letter && this.letter !== 'all') {
          letter_match = brand.title.toLowerCase().startsWith(this.letter.toLowerCase());
        }
        return query_match && letter_match;
      });
    }
  },
  mounted: function () {
    axios.get("/apps/api/brands").then(
        resp => {
          this.all_brands = resp.data.brands;
          this.collections = this.all_brands;
        },
        err => {
          console.error("Error fetching brands:", err, err.response)
        }
    );
  },
  watch: {
    query: function () {
      this.filter();
    },
    letter: function () {
      this.filter();
    }
  }
}
